import React from 'react';

const steps = [
  {
    title: 'Find a Restaurant',
    description: 'Browse restaurants near you and discover new cuisines.',
  },
  {
    title: 'Book the First Table',
    description:
      'Pay a small booking fee to secure your table. Your reservation is confirmed instantly.',
  },
  {
    title: 'Enjoy 50% Off',
    description:
      'Save on your meal while receiving the same great food and service as full-paying customers.',
  },
];

const HowItWorksSteps = () => (
  <>
    <h3 className="mb-7 font-serif text-lg text-brand-blue sm:text-xl">How it Works</h3>
    <div className="flex flex-col gap-5">
      {steps.map((step, index) => (
        <div key={step.title} className="flex items-start">
          <span className="mr-3 inline-flex size-9 min-w-9 items-center justify-center rounded-full bg-brand-blue text-sm font-bold text-white sm:size-[43px] sm:min-w-[42px] sm:text-md">
            {index + 1}
          </span>

          <p className="my-0.5 text-sm sm:my-1.5 sm:text-[19px] sm:leading-normal">
            <span className="font-bold">{step.title}</span> - {step.description}
          </p>
        </div>
      ))}
    </div>
    <p className="mt-7 text-sm font-bold sm:text-base">
      No hidden fees. Just great food at half the price.
    </p>
  </>
);

export default HowItWorksSteps;
